export default __webpack_public_path__ + "img/7c2ee177f589808e6505a569413e8c37.png";